import { defineMessages } from 'react-intl-next';

// TODO: sync with content designer
export const messages = defineMessages({
	options: {
		id: 'eoc-schedule.ui.list.edit-schedule.sidebar.edit-rotation.participant-list.participant.options',
		defaultMessage: 'Participant options',
		description: 'A button for opening participant options dropdown.',
	},
	actionsForParticipant: {
		id: 'eoc-schedule.ui.list.edit-schedule.sidebar.edit-rotation.participant-list.participant.actions-for-participant',
		defaultMessage: 'Actions for participant {participantName}',
		description: 'Label of a button for opening participant options dropdown',
	},
	replaceWithNoOne: {
		id: 'eoc-schedule.ui.list.edit-schedule.sidebar.edit-rotation.participant-list.participant.replaceWithNoOne',
		defaultMessage: 'Replace with no one',
		description: 'A button for replacing a participant with no one (responder type).',
	},
	deactivated: {
		id: 'eoc-schedule.ui.list.edit-schedule.sidebar.edit-rotation.participant-list.participant.deactivated',
		defaultMessage: '{name} (Deactivated)',
		description: 'Deactivated tag for user participant. Ex. Burak (Deactivated)',
	},
});
